import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';

export default class Breadcrumb extends Component {
  view() {
    const discussion = this.attrs.discussion;
    const post = this.attrs.post;
    if (!discussion) return null;

    // 获取群组信息（从 discussion 的属性中）
    const group = discussion.attribute && discussion.attribute('social_group');

    // 如果有 post，生成跳转到该 post 的链接，否则只跳转到讨论
    const discussionUrl = post && post.number() 
      ? app.route.discussion(discussion, post.number())
      : app.route.discussion(discussion);

    return (
      <div className="DiscussionBreadcrumb">
        <div className="breadcrumb-Component">
          {/* {group && (
              <Link 
                href={app.route('groupDetail', { id: group.id })} 
                className="params-span"
              >
                {group.name}/
              </Link>
          )} */}
          <Link 
            href={discussionUrl} 
            className="params-span current"
          >
            {discussion.title()}
          </Link>
        </div>
      </div>
    );
  }
}


